import * as React from 'react';
import {Cluster, Icon, Popover, Template, TIcons} from '@pluto-tv/assemble';

import DeleteConfirmation from 'components/deleteConfirmation';

export interface ITableActions<T> {
  icons: TIcons[];
  displayField?: string;
  deleteOption?: boolean;
  row: T;
  onClick(row: T, icon: TIcons): void;
}

const TableActionsFn = <T,>({deleteOption, icons, onClick, displayField = 'name', row}: ITableActions<T>) => {
  const [deleteVisible, setDeleteVisible] = React.useState(false);

  return (
    <Cluster>
      {icons.map(icon => (
        <Icon key={icon} icon={icon} onClick={() => onClick(row, icon)} space='small' />
      ))}
      {deleteOption && (
        <Popover appendToBody={true} manualTrigger={true} visible={deleteVisible}>
          <Template label='trigger'>
            <Icon color='delete' icon='delete' onClick={() => setDeleteVisible(true)} />
          </Template>
          <Template label='popover'>
            <DeleteConfirmation
              deleteItemTitle={row[displayField]}
              cancelButtonFunction={() => setDeleteVisible(false)}
              proceedButtonFunction={() => {
                setDeleteVisible(false);
                onClick(row, 'delete');
              }}
            />
          </Template>
        </Popover>
      )}
    </Cluster>
  );
};

TableActionsFn.displayName = 'TableActions';

export const TableActions = React.memo(TableActionsFn) as typeof TableActionsFn;
